// extracted by mini-css-extract-plugin
export default {"root":"VoteItem_root__Ki2Dy","alphabet":"VoteItem_alphabet__QjGp1","process":"VoteItem_process__r8D7F","bar":"VoteItem_bar__HlX3m","count":"VoteItem_count__1VB69"};